export class BrowserNotificationAction
{
    cancel(setNotificationModal, onClickCancelUserPermission)
    {
        setNotificationModal(false);
        onClickCancelUserPermission();
    }
}
